import { Component, Input, OnChanges } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { ChartConfiguration } from 'chart.js';
import { GenderDistributionPieReport } from '../../../../../pages/organization/campaigns/types/messagesTypes';
import { ThemedChart } from '../themed-chart';
import { barChartHeight, shareBarConfig } from '../chart-theme';
import { DistributionRow, toDistribution } from '../distribution';
import { formatCount } from '../../../../../../utils/sms';

/** Recipients by gender, as each group's share of the audience. */
@Component({
  selector: 'app-gender-distribution-graph',
  standalone: true,
  imports: [BaseChartDirective],
  templateUrl: './gender-distribution-graph.component.html',
  styleUrl: '../report-graph.css',
})
export class GenderDistributionGraphComponent extends ThemedChart implements OnChanges {
  @Input() graphData: GenderDistributionPieReport | null = null;

  rows: DistributionRow[] = [];
  total = 0;
  chartData: ChartConfiguration<'bar'>['data'] = { labels: [], datasets: [] };
  chartOptions: ChartConfiguration<'bar'>['options'] = {};
  height = barChartHeight(3);

  readonly formatCount = formatCount;

  get hasData(): boolean {
    return this.rows.some((row) => row.count > 0);
  }

  ngOnChanges() {
    const data = this.graphData;
    this.rows = data
      ? toDistribution(
          [
            { label: 'Male', count: data.totalMale },
            { label: 'Female', count: data.totalFemale },
            { label: 'Other', count: data.totalOther },
          ],
          data.totalRecipient
        )
      : [];
    this.total = Number(data?.totalRecipient) || this.rows.reduce((all, row) => all + row.count, 0);
    this.redraw();
  }

  protected render() {
    const { data, options } = shareBarConfig(
      this.tokens,
      this.rows.map((row) => row.label),
      this.rows.map((row) => row.share),
      (index) => `${this.rows[index]?.countLabel} recipients · ${this.rows[index]?.shareLabel}`
    );
    this.chartData = data;
    this.chartOptions = options;
    this.height = barChartHeight(this.rows.length);
  }
}
